export default __webpack_public_path__ + "static/media/Img0159.f63415d8.jpg";